<div class="retour-container">
  <a id="retourPage" [routerLink]="['/accueil']">{{'ACTIONS.RETOUR' | translate}}</a>
  <a *ngIf="showLastConnetion" id="retourPage" [routerLink]="['/favoris']">{{'ACTIONS.RETOUR_FAVORIS' | translate}}</a>
</div>
